/**
 * Analytics Actions
 * NgRx actions for analytics and reporting
 */
import { createAction, props } from '@ngrx/store';
import {
  AnalyticsOverview,
  DocumentAnalyticsRequest,
  DocumentAnalyticsResponse,
  ApiUsageAnalyticsRequest,
  ApiUsageAnalyticsResponse,
  CostAnalyticsRequest,
  CostAnalyticsResponse,
  ExportRequest,
  GroupBy,
  DateRangeRequest,
  TemplateAnalyticsResponse,
  ProviderAnalyticsResponse
} from '../models/analytics.models';

// Load Overview
export const loadOverview = createAction(
  '[Analytics] Load Overview',
  props<{ startDate?: Date; endDate?: Date }>()
);

export const loadOverviewSuccess = createAction(
  '[Analytics] Load Overview Success',
  props<{ overview: AnalyticsOverview }>()
);

export const loadOverviewFailure = createAction(
  '[Analytics] Load Overview Failure',
  props<{ error: string }>()
);

// Load Document Analytics
export const loadDocumentAnalytics = createAction(
  '[Analytics] Load Document Analytics',
  props<{ request: DocumentAnalyticsRequest }>()
);

export const loadDocumentAnalyticsSuccess = createAction(
  '[Analytics] Load Document Analytics Success',
  props<{ data: DocumentAnalyticsResponse }>()
);

export const loadDocumentAnalyticsFailure = createAction(
  '[Analytics] Load Document Analytics Failure',
  props<{ error: string }>()
);

// Load API Usage Analytics
export const loadApiUsageAnalytics = createAction(
  '[Analytics] Load API Usage Analytics',
  props<{ request: ApiUsageAnalyticsRequest }>()
);

export const loadApiUsageAnalyticsSuccess = createAction(
  '[Analytics] Load API Usage Analytics Success',
  props<{ data: ApiUsageAnalyticsResponse }>()
);

export const loadApiUsageAnalyticsFailure = createAction(
  '[Analytics] Load API Usage Analytics Failure',
  props<{ error: string }>()
);

// Load Cost Analytics
export const loadCostAnalytics = createAction(
  '[Analytics] Load Cost Analytics',
  props<{ request: CostAnalyticsRequest }>()
);

export const loadCostAnalyticsSuccess = createAction(
  '[Analytics] Load Cost Analytics Success',
  props<{ data: CostAnalyticsResponse }>()
);

export const loadCostAnalyticsFailure = createAction(
  '[Analytics] Load Cost Analytics Failure',
  props<{ error: string }>()
);

export const loadTemplateAnalytics = createAction(
  '[Analytics] Load Template Analytics',
  props<{ startDate?: Date; endDate?: Date }>()
);

export const loadTemplateAnalyticsSuccess = createAction(
  '[Analytics] Load Template Analytics Success',
  props<{ data: TemplateAnalyticsResponse }>()
);

export const loadTemplateAnalyticsFailure = createAction(
  '[Analytics] Load Template Analytics Failure',
  props<{ error: string }>()
);

export const loadProviderAnalytics = createAction(
  '[Analytics] Load Provider Analytics',
  props<{ startDate?: Date; endDate?: Date }>()
);

export const loadProviderAnalyticsSuccess = createAction(
  '[Analytics] Load Provider Analytics Success',
  props<{ data: ProviderAnalyticsResponse }>()
);

export const loadProviderAnalyticsFailure = createAction(
  '[Analytics] Load Provider Analytics Failure',
  props<{ error: string }>()
);

// Export Report
export const exportReport = createAction(
  '[Analytics] Export Report',
  props<{ request: ExportRequest }>()
);

export const exportReportSuccess = createAction(
  '[Analytics] Export Report Success',
  props<{ blob: Blob; filename: string }>()
);

export const exportReportFailure = createAction(
  '[Analytics] Export Report Failure',
  props<{ error: string }>()
);

// Set Date Range
export const setDateRange = createAction(
  '[Analytics] Set Date Range',
  props<{ dateRange: DateRangeRequest }>()
);

// Set Group By
export const setGroupBy = createAction(
  '[Analytics] Set Group By',
  props<{ groupBy: GroupBy }>()
);

// Refresh All Analytics
export const refreshAllAnalytics = createAction(
  '[Analytics] Refresh All Analytics'
);

// Clear Analytics
export const clearAnalytics = createAction(
  '[Analytics] Clear Analytics'
);

// Clear Error
export const clearError = createAction(
  '[Analytics] Clear Error'
);

